import { Component, OnInit } from "@angular/core";

@Component({
  selector: "ngx-privacy-policy",
  templateUrl: "./vta.privacy-policy.component.html",
  styleUrls: ["./vta.privacy-policy.component.scss"],
  standalone: false,
})
export class PrivacyPolicyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
